function isMwebUrl() {
  return (
    window.location.host.startsWith('m.') ||
    window.location.host.startsWith('m-local.')
  );
}
export default isMwebUrl;
